// extracted by mini-css-extract-plugin
module.exports = {"straightAnglePieContainer":"StraightAnglePie_straightAnglePieContainer__296i6"};